import { mapActions, mapGetters } from 'vuex';
import { random } from 'lodash';

export default {
  computed: {
    ...mapGetters('staffNotification', ['notifications', 'justReceivedNotifications', 'unreadNotifications']),
  },
  methods: {
    ...mapActions('staffNotification', {
      processNewStaffNotification: 'PROCESS_NEW_STAFF_NOTIFICATION',
      loadNotifications: 'LOAD_STAFF_NOTIFICATIONS',
      pinNotification: 'PIN_STAFF_NOTIFICATION',
      unpinNotification: 'UNPIN_STAFF_NOTIFICATION',
      dismissNotification: 'DISMISS_NOTIFICATION',
      dismissAndReadNotification: 'DISMISS_AND_READ_NOTIFICATION',
      deleteNotification: 'DELETE_STAFF_NOTIFICATION',
      deleteNotifications: 'DELETE_STAFF_NOTIFICATIONS',
      readNotification: 'READ_NOTIFICATION',
      unreadNotification: 'UNREAD_NOTIFICATION',
      readAllNotifications: 'READ_ALL_NOTIFICATIONS',
    }),
    async createFakeNotification() {
      const mock = {
        id: random(100000000, 999999999).toString(),
        title: 'Test fake notification',
        tag: 'Test',
        imageSrc: 'https://i.pinimg.com/originals/13/29/b9/1329b99581f16c46247afcbfe60e63c9.jpg',
        url: 'https://bcube.bitban.com/es-es/',
        creationDate: new Date().toISOString(),
        autoClose: 6000,
        justReceived: true,
      };
      await this.processNewStaffNotification(mock);
    },
    handleInput(notification) {
      if (!notification.url) {
        return;
      }
      if (!notification.readDate) {
        this.readNotification(notification);
      }
      const url = new URL(notification.url);
      console.debug(`navigate to ${notification.url}`);
      if (url.origin !== window.location.origin) {
        window.location.replace(url);
      } else {
        this.$router.push(url.pathname + url.search);
      }
    },
  },
};
